import SideTool from "@/global/components/side-tool";
import './index.less';
import { Input, Skeleton } from "antd";
import { ReactComponent as SearchSvg } from './icons/search.svg';
import { ReactComponent as CancelSvg } from './icons/cancel.svg';
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import TnMessage from "@/global/components/message";
import { SysLog } from "@/global/interface/project-manage/system-log";
import { getSystemLogs } from "@/api/project-manage/system-log";
import TnInput from "@/global/components/input/tn-input";

export default function SystemLog() {
    const { projectId } = useParams();
    const [searchKey, setSearchKey] = useState<string>('');
    const [systemLogs, setSystemLogs] = useState<SysLog[]>([]);
    const [filteredLogs, setFilteredLogs] = useState<SysLog[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!projectId) return;
        setLoading(true);
        getSystemLogs(+projectId).then(res => {
            let data: SysLog[] = res.data || [];
            setSystemLogs(data);
        }).finally(() => {
            setLoading(false);
        })
    }, [projectId])

    useEffect(() => {
        if (!searchKey || searchKey === '') {
            setFilteredLogs([...systemLogs]);
            return;
        }
        const filteredLogs = systemLogs?.filter(log => {
            const lowerCaseSearchKey = searchKey.toLowerCase();
            return log.searchKey.toLowerCase().includes(lowerCaseSearchKey) || log.userName.toLowerCase().includes(lowerCaseSearchKey);
        })
        setFilteredLogs(filteredLogs);
    }, [systemLogs, searchKey])

    const highlightText = (text, highlight) => {
        if (!highlight.trim()) {
            return text;
        }
        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = text.split(regex);
        return parts.map((part, index) =>
            regex.test(part) ? <span key={index} style={{ color: '#E71111' }}>{part}</span> : part
        );
    };

    return (
        <div className="system-log-container">
            <SideTool />
            <div className="system-log-panel">
                <TnInput
                    value={searchKey}
                    prefix={<SearchSvg />}
                    onTextChange={(e) => setSearchKey(e)}
                    placeholder="搜索时间、操作人、记录"
                    allowClear={{ clearIcon: <CancelSvg /> }}
                />
                <Skeleton loading={loading} active>
                    <div className="log-scroll-area">
                        {filteredLogs?.map((item, key) => (
                            <div key={key} className="log">
                                <div className="log-row">
                                    <span>{highlightText(dayjs(item.gmtCreate).format("YYYY-MM-DD HH:mm") || '', searchKey)}</span>
                                    <span>{highlightText(item?.userName || '', searchKey)}</span>
                                </div>
                                <div className="log-row">
                                    <span>{highlightText(item?.content || '', searchKey)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </Skeleton>

            </div>
        </div>
    )
}